import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import {
  AppCard,
  AppNoInfo,
} from '@/layout/AppComponents';
import BreadcrumbHandler from '../../../layout/components/breadcrumb/BreadcrumbHandler';
import useIsMounted from '../../../layout/components/hooks/useIsMounted';
import errorHandler from '@/layout/components/error/ErrorHandler';
import { axiosPath, path } from '../../../routing/helpers/router';
import * as currentPageAction from '../../../store/actions/currentPageAction';
import DynamicFormBase from './DynamicFormBase';
import DynamicFormSidebar from '../../../layout/screenSpecifics/Modules/DynamicForm/Sidebar/DynamicFormSidebar';
import AppLink from '@/routing/helpers/AppLink';
import axios from 'axios';

export default function DynamicFormHomeScreen() {
  const { moduleBridgeHex } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const moduleData = useSelector((s) => s?.module?.[moduleBridgeHex]?.moduleData);
  const [loading, setLoading] = useState(true);
  const [breadcrumb, setBreadcrumb] = useState();
  const [formData, setFormData] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    return () => {
      dispatch(currentPageAction.empty());
    };
  }, []);

  // > LOAD FORM DATA
  const loadFormData = useCallback(async () => {
    await axios
      .post(axiosPath('api_r_user_module_dynamicForm_home'), {
        moduleBridgeHex,
      })
      .then(({ data }) => {
        if (isMounted.current) {
          setFormData(data);
        }
      })
      .finally(() => setLoading(false));
  }, [moduleBridgeHex]);

  useEffect(() => {
    loadFormData();
  }, []);
  // < LOAD FORM DATA

  const handleContinue = useCallback(
    async (dynamicFormUserFormID) => {
      axios
        .post(axiosPath('api_r_user_module_dynamicForm_continue'), {
          moduleBridgeHex,
          dynamicFormUserFormID,
        })
        .then(({ data }) => {
          if (isMounted.current) {
            if (data?.step) {
              navigate(
                path({
                  name: 'user_module_dynamicForm_step',
                  params: {
                    moduleBridgeHex,
                    dynamicFormUserFormPageID: data?.dynamicFormUserFormPageID,
                  },
                }),
              );
            } else {
              navigate(
                path({
                  name: 'user_module_dynamicForm_endConfirm',
                  params: {
                    moduleBridgeHex,
                    dynamicFormUserFormPageID: data?.dynamicFormUserFormPageID,
                  },
                }),
              );
            }
          }
        })
        .catch((e) => dispatch(errorHandler(e)))
        .finally(() => setLoading(false));
    }, [moduleBridgeHex]);

  const handleAdd = useCallback(
    async () =>
      axios
        .post(axiosPath('api_r_user_module_dynamicForm_add'), {
          moduleBridgeHex,
        })
        .then(({ data }) => {
          if (isMounted.current) {
            navigate(
              path({
                name: 'user_module_dynamicForm_step',
                params: {
                  moduleBridgeHex,
                  dynamicFormUserFormPageID: data?.dynamicFormUserFormPageID,
                },
              }),
            );
          }
        })
        .catch((e) => dispatch(errorHandler(e)))
        .finally(() => setLoading(false)),
    [moduleBridgeHex],
  );

  return (
    <>
      <DynamicFormBase />
      <DynamicFormSidebar activeRoute="user_module_dynamicForm_home" />
      <BreadcrumbHandler
        paths={
          moduleData
            ? [
                {
                  name: moduleData?.moduleName,
                },
              ]
            : [{ name: '...' }]
        }
      />
      <main role="main" className="col-md-12 col-lg-12 px-md-4 mb-5">
        <div className="justify-content-between flex-wrap flex-md-nowrap align-items-center pt-0 pb-0 mb-0">
          {loading ? (
            <AppNoInfo minHeight={window.innerHeight - 60} />
          ) : (
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <AppCard header={moduleData?.moduleName}>
                    {formData?.existingUserForm && (
                      <button
                        type="button"
                        className="btn btn-block btn-success"
                        onClick={() => handleContinue(formData.existingUserForm.id)}
                      >
                        Continuar con Formulario existente (
                        {formData.existingUserForm.dateStamp})
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn btn-block btn-primary"
                      onClick={handleAdd}
                    >
                      Iniciar nuevo Formulario
                      {formData?.existingUserForm && (
                        <> (se eliminará el formulario sin terminar)</>
                      )}
                    </button>

                    {/* <AppLink
                      path="user_module_dynamicForm_add"
                      params={{
                        moduleBridgeHex,
                      }}
                      className="btn btn-block btn-primary"
                    >
                      Iniciar nuevo Formulario
                      {formData?.existingUserForm && (
                        <> (se eliminará el formulario sin terminar)</>
                      )}
                    </AppLink> */}
                  </AppCard>
                </div>
              </div>
              {formData?.finishedUserForms?.length > 0 && (
                <div className="row mt-3">
                  <div className="col-lg-12">
                    <AppCard header="Listado de Formularios ya realizados">
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th className="col-lg-2">Fecha</th>
                              <th className="col-lg-10">Descripción</th>
                            </tr>
                          </thead>
                          <tbody>
                            {formData.finishedUserForms.map((fuf) => (
                              <tr key={fuf.id}>
                                <td>
                                  <AppLink
                                    path="user_module_dynamicForm_end"
                                    params={{
                                      moduleBridgeHex,
                                      dynamicFormUserFormID: fuf.id,
                                    }}
                                  >
                                    {fuf?.dateStamp}
                                  </AppLink>
                                </td>
                                <td>{fuf?.name}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </AppCard>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </main>
    </>
  );
}
